// Icons
import { ReactComponent as SystemSettingsIcon } from "@/assets/icons/header/settings/SystemSettingsIcon.svg";
import { ReactComponent as AdministrationToolsIcon } from "@/assets/icons/header/settings/AdministrationToolsIcon.svg";
import { ReactComponent as SalesPerformanceVersionIcon } from "@/assets/icons/header/settings/SalesPerformanceVersionIcon.svg";
import { ReactComponent as PositionMappingIcon } from "@/assets/icons/header/settings/PositionMappingIcon.svg";
import { ReactComponent as UserAccessSettingsIcon } from "@/assets/icons/header/settings/UserAccessSettingsIcon.svg";
import { ReactComponent as GroupSettingsIcon } from "@/assets/icons/header/settings/GroupSettingsIcon.svg";
import { ReactComponent as PayItemsIcon } from "@/assets/icons/header/settings/PayItemsIcon.svg";
import { ReactComponent as PtoModalityIcon } from "@/assets/icons/header/settings/PtoModalityIcon.svg";
import { ReactComponent as QueueMappingIcon } from "@/assets/icons/header/settings/QueueMappingIcon.svg";
import { ReactComponent as FinancialStatementIcon } from "@/assets/icons/header/settings/FinancialStatementIcon.svg";

// Components
import RenderMenusOptions, { TRenderOptionConfiguration } from "./RenderMenusOptions";
// Constants
import actions from "@/Constants/actionsList";
// Hooks
import { useAuthorization } from "@/Common/hooks/Authorization/Authorization";
import { useWrapperLayer } from "@/Common/context/wrapperLayer/WrapperLayerContext";

export const SETTINGS_MENU_REQUIRED_ACTIONS = [
	actions.VIEW_SYSTEM_SETTINGS,
	actions.VIEW_ADMINISTRATION_TOOLS,
	actions.VIEW_SALES_PERFORMANCE_REPORT_FORMATS,
	actions.VIEW_POSITION_MAPPINGS,
	actions.VIEW_USER_ACCESS_SETTINGS,
	actions.VIEW_ACTION_GROUPS,
	actions.VIEW_PAY_ITEMS_MAPPING,
	actions.VIEW_PTO_MODALITY,
	actions.VIEW_QUEUE_MAPPINGS,
	actions.VIEW_FINANCIAL_STATEMENT_CONFIG,
];

const options: TRenderOptionConfiguration[] = [
	{
		title: "System Settings",
		link: "/system-settings",
		icon: <SystemSettingsIcon />,
		requiredActions: [actions.VIEW_SYSTEM_SETTINGS],
	},
	{
		title: "Administration Tools",
		link: "/administration-tools",
		icon: <AdministrationToolsIcon />,
		requiredActions: [actions.VIEW_ADMINISTRATION_TOOLS],
	},
	{
		title: "Sales Performance Versions",
		link: "/sales-performance-report-formats",
		icon: <SalesPerformanceVersionIcon />,
		requiredActions: [actions.VIEW_SALES_PERFORMANCE_REPORT_FORMATS],
	},
	{
		title: "Position Mapping",
		link: "/position-mapping",
		icon: <PositionMappingIcon />,
		requiredActions: [actions.VIEW_POSITION_MAPPINGS],
	},
	{
		title: "User Access Settings",
		link: "/user-access-settings",
		icon: <UserAccessSettingsIcon />,
		requiredActions: [actions.VIEW_USER_ACCESS_SETTINGS],
	},
	{
		title: "Group Settings",
		link: "/group-settings",
		icon: <GroupSettingsIcon />,
		requiredActions: [actions.VIEW_ACTION_GROUPS],
	},
	{
		title: "Payroll Mappings",
		link: "/payroll-mappings",
		icon: <PayItemsIcon />,
		requiredActions: [actions.VIEW_PAY_ITEMS_MAPPING, actions.VIEW_CUSTOM_FIELD_ITEMS_MAPPING],
	},
	{
		title: "PTO Modality",
		link: "/pto-modality",
		icon: <PtoModalityIcon />,
		requiredActions: [actions.VIEW_PTO_MODALITY],
	},
	{
		title: "Queue Mapping",
		link: "/queue-mapping",
		icon: <QueueMappingIcon />,
		requiredActions: [actions.VIEW_QUEUE_MAPPINGS],
	},
	{
		title: "Financial Statement Config",
		link: "/financial-statement-config",
		icon: <FinancialStatementIcon />,
		requiredActions: [actions.VIEW_FINANCIAL_STATEMENT_CONFIG],
	},
];

export default function SettingsMenu() {
	const { useMultipleAuth } = useAuthorization();
	const { isDisabled } = useWrapperLayer();
	const isAuthorized = useMultipleAuth(SETTINGS_MENU_REQUIRED_ACTIONS, "atLeastOne");

	if (!isAuthorized || isDisabled) {
		return null;
	}

	return <RenderMenusOptions arrayOptions={options} />;
}
